
export default {
  vessel: {
    single: {
      backgroundColor: 'grey-lightest',
      paddingX: 'sm',
      paddingY: 'md',
      lg: {
        padding: 'lg'
      }
    },
    double: {
      $extend: 'single',
      backgroundColor: 'white',
      shadow: 'lg'
    }
  },
  data() {
    return {
      starter: null,
      business: null,
      custom: null
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this

    this.starter = await $content(locale, 'shop/plans/starter').fetch()
    this.business = await $content(locale, 'shop/plans/business').fetch()
    this.custom = await $content(locale, 'shop/plans/custom').fetch()
  }
}
